import { bindable, customElement } from 'aurelia';
import template from './view-header.html';

@customElement({ name: 'view-header', template })
export class ViewHeader {
  @bindable public titleKey = '';
  @bindable public icon = '';
}
